module.exports = __webpack_public_path__ + "img/dentist.b496bb71.png";